import CartProduct from './CartProduct';
import '../App.css'

export default function Cart(props){
    let total = 0;

    function confirmOrder(){
        props.setOrderConfirmed(true)
        document.getElementById('root').scrollIntoView({
            behavior: 'smooth'
        });
    }
    return(
        <div className={props.cart.length === 0 ? "container-cart" : "container-cart non-empty-cart"}>
            <h2>Your Cart ({props.cart.length})</h2>

            { props.cart.length === 0 && 
            <div className='empty-cart'>
                <img src="./images/illustration-empty-cart.svg" alt="cart empty" />
                <p>Your added items will appear here</p>
            </div>
            }

            {
            <>
                {
                    props.cart.length > 0 &&
                    props.cart.map((product, index) => {
                        total = parseInt(total) + parseInt(product.total);
                        return <CartProduct 
                                    key={index}
                                    category = {product.category}
                                    quantity = {product.quantity}
                                    price = {product.price}
                                    total = {product.total}
                                    setCart={props.setCart}
                                />
                    })
                }
                { props.cart.length > 0 && 
                    <div className='cart-footer'>
                        <div className="cart-total">
                            <div>
                                <p>Order Total</p>
                            </div>
                            <div>
                                <h3>${total.toFixed(2)}</h3>
                            </div>
                        </div>

                        <div className="carbon-message">
                        <img src="./images/icon-carbon-neutral.svg" alt="carbon neutral" />
                        <p>This is a <span>carbon-neutral</span> delivery</p>
                        </div>

                        <button className='btn-confirm' onClick={confirmOrder}>Confirm Order</button>
                    </div>
                }
            </>
            }

    </div>
    )
}